import { NSARouterMakerResult } from "namirasoft-account-react";
import { FiscalYearFullRow, FiscalYearInputRow, FiscalYearRow } from "namirasoft-erp";
import { Component } from "react";
import { FiscalYearBranchesView } from "../components/FiscalYearBranchesView";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { }

export default class FiscalYearViewPage extends Component<Props>
{
    override render()
    {
        return (
            <ErpLayout<FiscalYearRow, FiscalYearInputRow>
                {...this.props}
                mode={ErpScopeMode.Filter}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.fiscal_year(this.props),
                    view: {
                        ui: {
                            getChildrenAfter: (id, row) =>
                            {
                                let row_full = row as FiscalYearFullRow;
                                return (
                                    <FiscalYearBranchesView
                                        {...this.props}
                                        fiscal_year_id={id}
                                        rows={row_full.branches}
                                    />
                                );
                            },
                        },
                    }
                }}>
                <></>
            </ErpLayout>
        );
    }
}